import { workloadScenarioSettingsLoaded } from "owa-scenario-settings/lib/actions/publicActions";
import { onModuleClick } from "owa-workloads";
import { LazyModule, registerLazyOrchestrator } from "owa-bundling";
import { orchestrator } from "satcheljs";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getMailboxInfoForModule, setModuleContextMailboxInfoAction, } from "owa-module-context-mailboxinfo";
import isFlexPaneShownHelper from "owa-app-pane-group-utils/lib/helpers/isFlexPaneShownHelper";
import { setSkipNextCloseForWorkloadSwitch } from "../utils/corePersistState";
import type * as lazyIndex from "../lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "TimePanelOpenStateHandlers" */ "../lazyIndex"), { name: "TimePanelOpenStateHandlers" });

// EAGER: Guard the upcoming unmount only if the panel is actually open. Boot reconciliation
// and the session-snapshot listener registration both run in the lazy handler — the chunk
// loads once registerLazyOrchestrator dispatches the action.
orchestrator(onModuleClick, actionMessage => {
    if (isGlobalFeatureEnabled("cal-myday-per-workload-persistence")) {
        const panelOpen = isFlexPaneShownHelper("OwaTimePanel", "myDay");
        if (panelOpen) {
            // Resolve target module's mailbox via the per-module map — do NOT trust
            // actionMessage.mailboxInfo. In multi-account Monarch the dispatcher passes
            // the global/primary account regardless of which account is active in the
            // target module. See PR thread 4368157.
            const mailboxInfo = getMailboxInfoForModule(actionMessage.module);
            setSkipNextCloseForWorkloadSwitch(mailboxInfo);
        }
    }
});

registerLazyOrchestrator(workloadScenarioSettingsLoaded, lazyModule, m => m.workloadScenarioSettingsLoadedLazyOrchestrator);

registerLazyOrchestrator(onModuleClick, lazyModule, m => m.onModuleClickLazyOrchestrator);

registerLazyOrchestrator(setModuleContextMailboxInfoAction, lazyModule, m => m.accountContextChangedLazyOrchestrator);
